export const MONTHS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec'
];

export const dateComp = (dateStr, showMonth) => {
  const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const date = dateStr
    .toString()
    .replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3')
    .split('-');
  const dateObj = new Date(date[0], date[1] - 1, date[2]);
  if (showMonth) {
    return MONTHS[dateObj.getMonth()] + ' ' + date[2];
  }
  return date[2] + ', ' + days[dateObj.getDay()];
};

export const getDateFromYYYYMMDDString = dateInYYYYMMDD => {
  const newDate = new Date(
    dateInYYYYMMDD.substring(0, 4),
    dateInYYYYMMDD.substring(4, 6) - 1,
    dateInYYYYMMDD.substring(6, 8)
  );
  return newDate;
};
